import { buildPrompt } from '@/ai/utils/promptBuilder'
import { getLanguageFromPath } from '@/ai/utils/helpers'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'

export const buildSwaggerFromCodePrompt = ({ codeSnippets }) => {
  const messages = []

  const systemMessage = buildPrompt([{ content: systemMessages.API_DOCUMENTATION_SPECIALIST }])
  messages.push(createSystemMessage(systemMessage))

  const promptSections = []

  promptSections.push({
    title: 'Task: Generate OpenAPI 3.x Specification from Source Code',
    content: 'Analyze the provided source code files for a complete application. Your task is to act as an API documentation specialist and generate a single, complete, and valid OpenAPI 3.x specification file in YAML format that accurately describes the API implemented in the code.',
    spacingAfter: 1
  })

  if (codeSnippets && codeSnippets.length > 0) {
    promptSections.push({
      title: 'Source Code Files for Analysis',
      spacingAfter: 1
    })
    codeSnippets.forEach((snippet) => {
      promptSections.push({
        title: `File path: ${snippet.path}`,
        contentType: 'codeblock',
        language: getLanguageFromPath(snippet.path),
        content: snippet.content
      })
    })
  }

  promptSections.push({
    title: 'Instructions and Rules',
    contentType: 'bullet',
    content: [
      'Scan all files to find route definitions (e.g., `app.use`, `router.get`, `router.post`).',
      'Combine base paths from main server files with specific routes from router files to determine the full endpoint paths (e.g., \'/api\' + \'/todos\' = \'/api/todos\').',
      'Analyze controller functions to determine request body schemas, path parameters, and potential success and error responses.',
      'Analyze model or entity files to build the schemas for the `components` section.',
      'The entire output MUST be a single, valid YAML document.',
      'DO NOT include any explanations, comments, or any text whatsoever outside of the YAML content. Your response must start directly with \'openapi: 3.0.3\'.'
    ]
  })

  promptSections.push({
    title: 'CRITICAL OUTPUT FORMATTING RULES',
    contentType: 'bullet',
    content: [
      'Your response MUST be the raw YAML content ONLY.',
      'DO NOT wrap the YAML in Markdown code fences (e.g., ```yaml).',
      'DO NOT include any introductory text, explanations, summaries, or any text whatsoever outside of the YAML content.',
      'Your response MUST begin with the literal string \'openapi: 3.0.3\' on the very first line and end with the last line of the YAML specification.'
    ]
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
